import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import { chatStyle } from './style';

export type MessageBotProps = {
  message: string;
};

export function MessageBot({ message }: MessageBotProps) {
  const style = chatStyle();

  if (!message) {
    return null;
  }

  return (
    <div className={style.messageBot()} data-testid="ai-bot-message">
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {message}
      </ReactMarkdown>
    </div>
  );
}
